import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsHub() {
  return <SectionHub sectionPath="03-fundamentals" />;
}
